import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CoingeckoService } from 'app/core/services/coingecko.service';
import { LocalStorageService } from 'app/core/services/local-storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  moduleId: module.id,
  selector: 'navbar-cmp',
  templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;

  settings: Settings = {} as Settings;
  selectedOption = '';
  options: string[] = [
    'PHP',
    'USD'
  ]
  public isCollapsed = true;
  @ViewChild("navbar-cmp", { static: false }) button;

  constructor(location: Location, private renderer: Renderer2, private element: ElementRef, private router: Router,
    private titleService: Title, private coinGeckoService: CoingeckoService, private localStorageService: LocalStorageService) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter(listTitle => listTitle);
    var navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
    this.router.events.subscribe((event) => {
      this.sidebarClose();
    });

    this.loadSettings();
    this.refreshCurrentRates(this.settings.currency);
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        this.titleService.setTitle(this.listTitles[item].menuTitle + ' | Zambo Guild Games');
        return this.listTitles[item].pageTitle;
      }
    }
    return '';
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }
  sidebarOpen() {
    const toggleButton = this.toggleButton;
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);

    html.classList.add('nav-open');
    if (window.innerWidth < 991) {
      mainPanel.style.position = 'fixed';
    }
    this.sidebarVisible = true;
  };
  sidebarClose() {
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = '';
      }, 500);
    }
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    html.classList.remove('nav-open');
  };
  collapse() {
    this.isCollapsed = !this.isCollapsed;
    const navbar = document.getElementsByTagName('nav')[0];
    if (!this.isCollapsed) {
      navbar.classList.remove('navbar-transparent');
      navbar.classList.add('bg-white');
    } else {
      navbar.classList.add('navbar-transparent');
      navbar.classList.remove('bg-white');
    }

  }

  loadSettings(): void {
    this.settings = this.localStorageService.getInfo();

    if (!this.settings) {
      this.settings = {} as Settings;
      this.settings.currency = 'PHP';
      this.localStorageService.setInfo(this.settings);
    }
  }

  refreshCurrentRates(currency: string = null): void {
    if(!this.settings) {
      this.loadSettings();
    }
    
    this.settings.currency = currency;
    this.selectedOption = currency;

    this.coinGeckoService.getSlpCurrentPrice(currency).subscribe(
      price => {
        this.settings.slpRate = price;
        this.localStorageService.setInfo(this.settings);
      }
    );

    this.coinGeckoService.getAxsCurrentPrice(currency).subscribe(
      price => {
        this.settings.axsRate = price;
        this.localStorageService.setInfo(this.settings);
      }
    );

    this.coinGeckoService.getEthCurrentPrice(currency).subscribe(
      price => {
        this.settings.ethRate = price;
        this.localStorageService.setInfo(this.settings);
      }
    );
  }

}
